import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AzmoonMaharatDetail_Files_Interface, Empty_AzmoonMaharatDetail_Files_Interface } from 'src/app/Interface/AzmoonMaharatDetail_Files_Interface';
import { AzmoonMaharatDetail_Interface, Empty_AzmoonMaharatDetail_Interface } from 'src/app/Interface/AzmoonMaharatDetail_Interface';

import { AzmoonMaharatRequest_Interface, Empty_AzmoonMaharatRequest_Interface } from 'src/app/Interface/AzmoonMaharatRequest_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { AzmoonMaharatService } from 'src/app/Service/AzmoonMaharat/AzmoonMaharat.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-AzmoonMaharatRequestList',
  templateUrl: './AzmoonMaharatRequestList.component.html',
  styleUrls: ['./AzmoonMaharatRequestList.component.scss']
})
export class AzmoonMaharatRequestListComponent implements OnInit {

  Token:String=""
  Filter_title:string=""
  page:number=0;
  Procssing:boolean=false
  BaseUrl = environment.BaseUrl+"File/AzmoonMaharat/"
  modalRef_Delete: any;
  modalRef_SignIn: any;

  constructor(
    private AzmoonMaharat_Service:AzmoonMaharatService,
    private Alertify_Service:AlertifyService,
    private Nav_Service: NavService,
    private modalService: BsModalService
  ) { }


  DataList_AzmoonMaharat:Array<AzmoonMaharatRequest_Interface>=[]
  Data_Seleted_Delete:AzmoonMaharatRequest_Interface=Empty_AzmoonMaharatRequest_Interface()

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');

    this.AzmoonMaharatFileForm = new FormGroup({
      title: new FormControl(null, Validators.required),
      templateSrc: new FormControl(null),
    })

    this.Nav_Service.CheckValidPage(this.Token, 2222).subscribe(
      data => {
        this.ReadData_AzmoonMaharat()   
      }
      , error => {
        localStorage.clear()
        location.reload();
      }
    )
 
  }

  ReadData_AzmoonMaharat(){
    this.Procssing=true
    this.AzmoonMaharat_Service.GetSignInCustomer(this.Token).subscribe(
      data=>{
        this.DataList_AzmoonMaharat=data
        this.Procssing=false
      }
    )
  }

  Change_Filter_title(){
    this.page=0
  }

  openModal(template: TemplateRef<any>, Record:AzmoonMaharatRequest_Interface) {
    this.Data_Seleted_Delete = Record
    this.modalRef_Delete = this.modalService.show(template);
  }


  CheckInPriodStep(step:AzmoonMaharatDetail_Interface, status:Array<AzmoonMaharatDetail_Interface>){
    for(let item of status)
    {
      if(item.id==step.id)
        return true
    }
    return false
  }



  
  //#region Files
  FileDataLise: Array<AzmoonMaharatDetail_Files_Interface> = []
  Data_Seleted_Delete_Detail: AzmoonMaharatDetail_Interface = Empty_AzmoonMaharatDetail_Interface()
  OnSubmitFile() {

    var temp: AzmoonMaharatDetail_Files_Interface = Empty_AzmoonMaharatDetail_Files_Interface()
    temp.id = 0
    temp.title = this.get_FormFile_title().value
    temp.templateSrc = this.get_FormFile_templateSrc().value

    this.FileDataLise.push(temp)

    this.Alertify_Service.SuccessMessage("The file was added to the list")
  }

  RemoveFile(id: number) {
    this.FileDataLise.splice(id, 1)
    this.Alertify_Service.SuccessMessage("The file was removed from the list")
  }

  UploadTemplate(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();


    for (const file of files) {
      formData.append(file.name, file);
    }

    this.AzmoonMaharat_Service.uploadFile(formData).subscribe(
      data => {
        if (data['id'] == 0) {
          this.Alertify_Service.ErrorMessage(data['filename'])
        }
        else {
          this.Alertify_Service.SuccessMessage("The file was uploaded successfully")
          this.get_FormFile_templateSrc().setValue(data['filename'])
        }
      }
    )

  }

  openModalFile(template: TemplateRef<any>, Record: AzmoonMaharatDetail_Interface) {
    this.Data_Seleted_Delete_Detail = Record
    this.get_FormFile_title().setValue("")
    this.get_FormFile_templateSrc().setValue("")
    this.modalRef_File = this.modalService.show(template);
  }

  //#endregion

  //#region  Form File
  modalRef_File: any;
  AzmoonMaharatFileForm: FormGroup;

  get_FormFile_title() {
    return this.AzmoonMaharatFileForm.get('title') as FormControl;
  }
  get_FormFile_templateSrc() {
    return this.AzmoonMaharatFileForm.get('templateSrc') as FormControl;
  }

  SubmitRequestSignInFile() {
    this.Procssing = true

    this.AzmoonMaharat_Service.SubmitRequestCustomerSignInFile(
      this.Data_Seleted_Delete_Detail.id,
      this.get_FormFile_title().value,
      this.get_FormFile_templateSrc().value,
      this.Token).subscribe(
        data => {

          var temp:AzmoonMaharatDetail_Files_Interface=Empty_AzmoonMaharatDetail_Files_Interface()

          temp.id = data['id']
          temp.title = this.get_FormFile_title().value
          temp.templateSrc = this.get_FormFile_templateSrc().value

          this.Data_Seleted_Delete_Detail.file.push(temp)

          this.Alertify_Service.SuccessMessage("The information was registered successfully")

          this.ReadData_AzmoonMaharat()
        }
      )
  }

  DeleteRequestSignInFile(item:AzmoonMaharatDetail_Interface) {
    this.modalRef_File.hide()
    this.Procssing = true
    this.AzmoonMaharat_Service.DeleteRequestCustomerSignInFile(
      item.id,
      this.Token).subscribe(
        data => {
          this.Alertify_Service.SuccessMessage("The information was registered successfully")
          this.ReadData_AzmoonMaharat()
        }
      )
  }

  SubmitRequestCustomerSignIn() {
    this.modalRef_File.hide()
    this.Procssing = true
    this.AzmoonMaharat_Service.SubmitRequestCustomerSignIn(
      this.Data_Seleted_Delete_Detail.id,
      this.Token).subscribe(
        data => {
          this.Alertify_Service.SuccessMessage("The information was registered successfully")
          this.ReadData_AzmoonMaharat()
        }
      )
  }

  //#endregion




}
